import { useState } from "react";
import { getValueOrPlaceHolder } from "../../../Utils/helpers/commonhelper";

export const DealDetailsCard = ({ dealData }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleDetailExpand = () => setExpanded((prev) => !prev);
    return (
        <div
            className="deal-details-card"
            style={{
                background: "#fff",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                marginBottom: "1rem",
                overflow: "hidden", // Ensures header background follows border radius
            }}
        >
            <div
                style={{
                    padding: "12px 16px 3px 16px",
                }}
            >
                <p className="mb-0  " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>
                    Associated Lead
                </p>
            </div>

            <div className="p-3">
                {/* Top Row: Title & Requirement */}
                <div className="row g-3 mb-3">
                    <div className="col-12">
                        <span style={labelStyle} className="mb-1">Title</span>
                        <p className="mb-0 fw-semibold text-dark" style={{ fontSize: "15px" }}>
                            {dealData?.deal_name || "Untitled Deal"}
                        </p>
                    </div>

                    <div className="col-12">
                        <span style={labelStyle} className="mb-1">Requirement</span>
                        <p
                            className={`mb-0 text-secondary ${expanded ? "" : "text-truncate"}`}
                            style={{
                                fontSize: "13px",
                                lineHeight: "1.5",
                                display: expanded ? "block" : "-webkit-box",
                                WebkitLineClamp: expanded ? "unset" : "2",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden"
                            }}
                        >
                            {getValueOrPlaceHolder(dealData?.requirement)}
                        </p>
                        {dealData?.requirement?.length > 100 && (
                            <button
                                onClick={toggleDetailExpand}
                                className="btn btn-link p-0 mt-1 text-decoration-none fw-bold"
                                style={{ fontSize: "11px", color: "#7a3a5e" }}
                            >
                                {expanded ? "SHOW LESS" : "VIEW FULL REQUIREMENT"}
                            </button>
                        )}
                    </div>
                </div>

                <div
                    className="row g-2 pt-1"
                >
                    <div className="col-6">
                        <span style={labelStyle} className="mb-1">Currency</span>
                        <p className="mb-0 fw-medium text-dark" style={{ fontSize: "13px" }}>
                            Indian Rupees (INR)
                        </p>
                    </div>
                    <div className="col-6">
                        <span style={labelStyle} className="mb-1">Budget</span>
                        <p className={`mb-0  text-dark d-flex align-items-center ${dealData?.total_budget && "fw-bold"}`} style={{ fontSize: "14px" }}>
                            {dealData?.total_budget && "₹"} {getValueOrPlaceHolder(dealData?.total_budget, "No Budget")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const labelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};